<template>
  <transition name="network-error">
    <div  v-if="networkErrorVissible" class="network-error">
     <i class="el-icon-error"></i> {{ $t('labels.no_internet_connection') }}
    </div>
  </transition>
</template>
<script>
  export default {

  }
</script>
<style lang="scss">
.network-error {
  position: fixed;
  left: 50%;
  top: 20px;
  min-width: 380px;
  display: flex;
  align-items: center;
  z-index: 9999;
  padding: 15px 15px 15px 20px;
  background-color: #fef0f0;
  border: 1px solid #fde2e2;
  transform: translate(-50%, 0);
  border-radius: 4px;
  overflow: hidden;
  color: #f56c6c;
  line-height: 1;

  i {
    margin-right: 10px;
    font-size: 1.2em;
  }
}

.network-error-enter-active, .network-error-leave-active {
  transition: all .3s;
}
.network-error-enter, .network-error-leave-to {
  transform: translate(-50%, -10px);
  opacity: 0;
}
</style>
<script>
export default {
  computed: {
    networkErrorVissible: self => self.$store.state.appInterface.networkErrorVissible
  }
}
</script>